import Vue from "vue"
import router from "./router"
import store from "@/store"
import http from "@/store/adapters/http"

const Session = {

  install(Vue, options) {

    Vue.prototype.$session = {

      session: null,
      user: null,
      authorize (loginToken) {
        return store.create('sessions', {applicationId: 3, loginToken})
          .then((response) => {
            if(response.token) {
              sessionStorage.setItem('token', response.token)
              http.defaults.httpConfig.headers.common.token = response.token
            }
            this.session = response
            this.user = response.user
            http.http.interceptors.response.use((response) => {
              return response
            }, (error) => {
              if(error.status === 401) {
                _.defer(() => {
                  router.push({name: "logout"})
                })
              }
              return Promise.reject(error);
            })
            return Promise.resolve(response)
          })
          .catch((error) => {
            sessionStorage.removeItem('token')
            return Promise.reject(error)
          })
      },
      destroy () {
        if(this.session) {
          return this.session.DSDestroy().then(() => {
            sessionStorage.removeItem('token')
          })
        } else {
          sessionStorage.removeItem('token')
          return Promise.resolve()
        }
      }

    }

  }

}

Vue.use(Session)

// router.beforeEach((to, from, next) => {
//   console.log(Vue.$session)
//   console.log('global', to, from, next)
// })

export default Session



// WEBPACK FOOTER //
// ./src/initializers/session.js